import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import * as _ from 'lodash';
import { catchError, map, Observable, of } from 'rxjs';
import { SessionService } from '../services/session.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      const tenantId = this.router.getCurrentNavigation()?.extractedUrl.queryParams['tenantid'];
      const linkGuid = this.router.getCurrentNavigation()?.extractedUrl.queryParams['linkguid'];

      if (!_.isNil(tenantId) && tenantId !== '' && !_.isNil(linkGuid) && linkGuid !== '') {
        return this.authService.validateLinkGuid(tenantId, linkGuid).pipe(
          map(value => {
          
          this.sessionService.setSessionDetailsFromLoginResult(value);
          return true;
        }), catchError((error) => {
          console.log(error);

          this.router.navigate(['error'], { state: { errorMessage: error.error.message } });
          return of(false);
        }));
      } else {
        this.router.navigate(['login']);
        return false;
      }
    } else {
      return true;
    }
  }
}
